<section class="login-block">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->
        <form novalidate #forgetForm="ngForm" (submit)="forgetForm.valid && submit()">
          <div class="text-center">
            <img class="header-logo" src="../../../assets/images/urbansofa_logo_white.png" alt="logo.png">
          </div>
          <div class="auth-box card">
            <div class="card-block">
              <div class="row m-b-20">
                <div class="col-md-12">
                  <h3 class="text-center">{{'auth.forgot_password.title'|translate}}</h3>
                </div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.signin.username'|translate}}</label>
                <input type="text" name="userName" #userName="ngModel" [(ngModel)]="username" class="form-control"
                       required>
                <span class="form-bar"></span>
                <div class="messages text-danger"
                     *ngIf="userName.invalid && userName.dirty && userName.errors?.required">
                  {{'errors.required'|translate}}
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-end">
                  <a class="f-w-600" [routerLink]="['/login']">{{'auth.forgot_password.back_to_login'|translate}}</a>
                </div>
              </div>
              <div class="row m-t-30">
                <div class="col-md-12">
                  <button [disabled]="!forgetForm.valid"
                          [ngClass]="{'btn-disabled': !forgetForm.valid, 'disabled': !forgetForm.valid}" type="submit"
                          class="btn btn-primary btn-md btn-block text-center m-b-20 ripple light">
                    {{'auth.forgot_password.button'|translate}}
                  </button>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-12">
                  <a [routerLink]="['/']"
                     class="text-inverse text-start m-b-0">{{'auth.signin.description'|translate}}</a>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
